import React from 'react';

const ImportUsersSkeleton: React.FC = () => {
  return (
    <div className="space-y-4 mt-6">
      {/* Only dynamic list rows skeleton; header/search/buttons remain static in the drawer */}
      <div className="border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={`user-row-skel-${i}`} className="p-4 border-b border-gray-200 dark:border-gray-700 last:border-b-0">
            <div className="flex items-center space-x-3">
              <div className="w-4 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
              <div className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse" />
              <div className="flex-1">
                <div className="w-40 h-4 bg-gray-200 dark:bg-gray-700 rounded animate-pulse mb-2" />
                <div className="w-56 h-3 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImportUsersSkeleton;
